import GoogleClientBase from "./GoogleClientBase";
import { googleJson } from "./request";

class Slides extends GoogleClientBase {
  getLink(fileId: string): string {
    return `https://docs.google.com/presentation/d/${fileId}`;
  }

  async create(title: string): Promise<string> {
    const response = await googleJson<{ presentationId?: string }>("https://slides.googleapis.com/v1/presentations", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ title }),
    });
  
    const { presentationId } = response;

    if (!presentationId) {
      throw new Error("Google Slides Presentation created with empty ID.");
    }

    return presentationId;
  }
};

export default new Slides();
